import { KeyboardEvent } from 'react';
import {
  BaseDataTableProps,
  BasePaginationTableProps,
  BaseVirtualListProps,
  RowsDataUseProps,
} from '../rows-data/types';

export const inputFieldSeachOnKeyDown = (onSearch?: () => void) => {
  return onSearch
    ? (e: KeyboardEvent<any>) => {
        if (e.key === 'Enter') {
          onSearch();
        }
      }
    : undefined;
};
export const isMobile = window.innerWidth < 480;

/*
 * Vrací základní propsy pro DataTable a ClientTable
 */
export const getDataTableProps = <ID>(
  rowsData: RowsDataUseProps<undefined, ID>
): BaseDataTableProps<ID> => {
  return {
    lastVisitedRowIndex: rowsData.rows.lastVisitedRowIndex,
    setLastVisitedRowIndex: rowsData.rows.setLastVisitedRowIndex,
    checkedIds: rowsData.rows.checkedIds,
    setCheckedIds: rowsData.rows.setCheckedIds,
    sort: rowsData.rows.sort,
    onSort: rowsData.rows.setSort,
  };
};

/*
 * Vrací základní propsy pro VirtualList
 */
export const getVirtualListProps = <ID>(
  rowsData: RowsDataUseProps<undefined, ID>
): BaseVirtualListProps<ID> => {
  return {
    checkedIds: rowsData.rows.checkedIds,
    setCheckedIds: rowsData.rows.setCheckedIds,
  };
};

/*
 * Vrací základní propsy pro PaginationTable
 */
export const getPaginationTableProps = <ID>(
  rowsData: RowsDataUseProps<undefined, ID>
): BasePaginationTableProps<ID> => {
  return {
    lastVisitedRowIndex: rowsData.rows.lastVisitedRowIndex,
    setLastVisitedRowIndex: rowsData.rows.setLastVisitedRowIndex,
    checkedIds: rowsData.rows.checkedIds,
    setCheckedIds: rowsData.rows.setCheckedIds,
    sort: rowsData.rows.sort,
    onSort: rowsData.rows.setSort,
    page: rowsData.pagination.page,
    onPageChange: rowsData.pagination.setPage,
    pageSize: rowsData.pagination.pageSize,
  };
};
